import { createFileRoute } from "@tanstack/react-router";

import AddAccountFinal from "@/features/onboarding/AddAccountFinal";
import BasicLayout from "@/layouts/Basic";

export const Route = createFileRoute("/_auth-basic/add-account-final")({
  component: () => (
    <BasicLayout>
      <AddAccountFinal />
    </BasicLayout>
  ),
});
